import styled from "styled-components";

export const Content = styled.div(() => ({
    display: "flex",
    flexDirection: "column" as const,
}));
